import { filterMultipleAutoComplete_template as VendorFilterMultipleAutoComplete_template } from '@valnet/vnKnockoutJsTemplates/filterMultipleAutoComplete_template';
/**
 * App-owned autocomplete filter that splits multi-class container strings.
 * Older vnTemplate builds call classList.add() without splitting on spaces,
 * which throws InvalidCharacterError for values like
 * "lib-dropdown lib-dropdown--autocomplete".
 */
export class filterMultipleAutoComplete_template extends VendorFilterMultipleAutoComplete_template {
    getMainElementClasses() {
        return String(this.filterContainerClass || '')
            .trim()
            .split(/\s+/)
            .filter(Boolean);
    }
}
